import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { scrollToId } from "@/lib/scroll";
import { ASSETS } from "@/data/content";

const SECTIONS = ["perfil", "estadisticas", "trayectoria", "videos", "galeria", "mercado", "contacto"];

export default function Nav() {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#07090E]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <button
          data-testid="nav-home-link"
          onClick={() => window.__lenis?.scrollTo(0) ?? window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <span className="flex items-center rounded-md bg-white px-2 py-1">
            <img src={ASSETS.logoIkons} alt="IKONS by Solocracks" className="h-5 w-auto" />
          </span>
          <span className="hidden font-display text-sm font-bold uppercase tracking-[0.2em] text-slate-200 sm:block">
            A. Cuadra
          </span>
        </button>

        <nav className="hidden items-center gap-6 lg:flex">
          {SECTIONS.map((s) => (
            <button
              key={s}
              data-testid={`nav-${s}-link`}
              onClick={() => go(s)}
              className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-400 transition-colors duration-300 hover:text-sky-400"
            >
              {t.nav[s]}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="flex items-center rounded-full border border-white/10 p-0.5" data-testid="lang-toggle">
            {["es", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-toggle-${l}`}
                onClick={() => setLang(l)}
                className={`rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-widest transition-colors duration-300 ${
                  lang === l ? "bg-sky-400 text-[#07090E]" : "text-slate-400 hover:text-slate-200"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <button
            data-testid="nav-menu-button"
            onClick={() => setOpen(!open)}
            className="rounded-md p-2 text-slate-300 lg:hidden"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-white/5 bg-[#07090E]/95 px-4 py-4 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {SECTIONS.map((s) => (
              <button
                key={s}
                data-testid={`nav-mobile-${s}-link`}
                onClick={() => go(s)}
                className="rounded-md px-3 py-2.5 text-left text-sm font-semibold uppercase tracking-[0.15em] text-slate-300 transition-colors hover:bg-white/5 hover:text-sky-400"
              >
                {t.nav[s]}
              </button>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
